import { createReducer } from 'deox';
import { Organisation, Paging, Invitations } from '@/types';
import {
  fetchOrganisationActions,
  fetchOrganisationApiKeyActions,
  fetchInvitationsActions,
} from '../actions';

export interface OrganisationState {
  data?: Organisation;
  apiKey: string;
  invitations: {
    data: Invitations[];
    paging: Paging;
  };
}

const initialState: OrganisationState = {
  data: undefined,
  apiKey: '',
  invitations: {
    data: [],
    paging: {
      pageNumber: 0,
      pageSize: 0,
      totalRecords: 0,
    },
  },
};

const organisationReducer = createReducer(initialState, (handleAction) => [
  handleAction(fetchOrganisationActions.success, (state, { payload }) => ({
    ...state,
    data: payload.organisation,
  })),
  handleAction(fetchOrganisationApiKeyActions.success, (state, { payload }) => ({
    ...state,
    apiKey: payload.apiKey,
  })),
  handleAction(fetchInvitationsActions.success, (state, { payload }) => ({
    ...state,
    invitations: payload,
  })),
]);

export default organisationReducer;
